module.exports = __webpack_public_path__ + "img/dish_mobile.c496faa8.png";